import { ALL_TEAMS_NEW_TEMP, TEAM_TYPES } from 'common/constants/constants';

export const createTeamsWithAllteams = teams => {
  // TO DO: delete this mock mode when BE of all teams group is ready

  let teamsWithAllTeams = teams.map(team => {
    if (!team.parent_id && team.type !== TEAM_TYPES.ALL_CONTRIBUTORS) {
      team.parent_id = ALL_TEAMS_NEW_TEMP.id;
    }
    return team;
  });

  teamsWithAllTeams = [ALL_TEAMS_NEW_TEMP, ...teamsWithAllTeams];

  return teamsWithAllTeams;
};
